import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }

import ErrorModal from "@/components/modals/error.vue"
  import {Session as SessionClient} from "@/endpoints/rutsolve/gql/resolvers/session"
  import CheckboxButton from "@/components/checkbox_button.vue"
  import Button from "@/components/button.vue"
  import SecretInput from "@/components/inputs/secret.vue"
  import TextInput from "@/components/inputs/text.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import {RutsolveToken} from "@/storage/rutsolve_token"
  import router from "@/router"
  import Breadcrumb from "@/components/breadcrumb.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'session',
  setup(__props) {

  const error = ref<Error>(null)
  const sessionClient = new SessionClient()
  const loginID = ref<string>(null)
  const loginSecret = ref<string>(null)
  const saveSession = ref<boolean>(false)
  const sessionRoles = ref<Array<string>>(null)

  onBeforeMount( () => {
    verifySession()
  })

  async function verifySession() {
    try {
      sessionRoles.value = await sessionClient.roles()
    } catch {
      sessionRoles.value = null
    }
  }

  async function startSession() {
    if (!loginID.value || !loginSecret.value) {
      return
    }
    try {
      const token = await sessionClient.start(loginID.value, loginSecret.value)
      RutsolveToken.write(token, saveSession.value)
      router.go(0)
    } catch (e) {
      error.value = e
    }
  }

  function stopSession() {
    RutsolveToken.delete()
    router.go(0)
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Session"
          }),
          _cache[8] || (_cache[8] = _createElementVNode("h1", null, " Session ", -1)),
          (sessionRoles.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[7] || (_cache[7] = _createElementVNode("h2", null, " Roles ", -1)),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sessionRoles.value, (role) => {
                    return (_openBlock(), _createElementBlock("li", { key: role }, _toDisplayString(role), 1))
                  }), 128))
                ]),
                _createVNode(Button, {
                  title: "Stop Session",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (stopSession()))
                })
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (startSession()), ["enter"]))
              }, [
                _createVNode(TextInput, {
                  value: loginID.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((loginID).value = $event)),
                  title: "Login ID"
                }, null, 8, ["value"]),
                _createVNode(SecretInput, {
                  value: loginSecret.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((loginSecret).value = $event)),
                  title: "Login Secret"
                }, null, 8, ["value"]),
                _createVNode(CheckboxButton, {
                  value: saveSession.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((saveSession).value = $event)),
                  title: "Save Session"
                }, null, 8, ["value"]),
                _createVNode(Button, {
                  title: "Start Session",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (startSession()))
                })
              ], 32))
        ]),
        _: 1
      }),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[6] || (_cache[6] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})